var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolio3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333496,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#FF9D59"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1988_5129",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 41,
    height: 40
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.3335,
    y: 20,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1988_5129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.3334 56.6666C38.0279 56.6666 35.8612 56.2291 33.8334 55.3541C31.8056 54.4791 30.0417 53.2916 28.5417 51.7916C27.0417 50.2916 25.8542 48.5277 24.9792 46.4999C24.1042 44.4721 23.6667 42.3055 23.6667 39.9999C23.6667 37.6944 24.1042 35.5277 24.9792 33.4999C25.8542 31.4721 27.0417 29.7083 28.5417 28.2083C30.0417 26.7083 31.8056 25.5208 33.8334 24.6458C35.8612 23.7708 38.0279 23.3333 40.3334 23.3333H41.7222V36.9862C42.2963 37.2545 42.764 37.6549 43.1251 38.1874C43.4862 38.7199 43.6667 39.3241 43.6667 39.9999C43.6667 40.9166 43.3404 41.7013 42.6876 42.3541C42.0348 43.0069 41.2501 43.3333 40.3334 43.3333C39.4167 43.3333 38.632 43.0069 37.9792 42.3541C37.3265 41.7013 37.0001 40.9166 37.0001 39.9999C37.0001 39.3241 37.1806 38.7176 37.5417 38.1803C37.9029 37.6434 38.3705 37.2453 38.9447 36.9862V32.9028C37.2594 33.2362 35.8658 34.0578 34.7638 35.3678C33.6622 36.6781 33.1113 38.2221 33.1113 39.9999C33.1113 41.9999 33.8149 43.7037 35.2222 45.1112C36.6297 46.5184 38.3334 47.222 40.3334 47.222C42.3334 47.222 44.0372 46.5184 45.4447 45.1112C46.8519 43.7037 47.5555 41.9999 47.5555 39.9999C47.5555 38.9074 47.3402 37.9051 46.9097 36.9928C46.4791 36.0809 45.8888 35.287 45.1388 34.6112L47.1251 32.6249C48.0973 33.5416 48.8751 34.6319 49.4584 35.8958C50.0418 37.1596 50.3334 38.5277 50.3334 39.9999C50.3334 42.7777 49.3612 45.1388 47.4167 47.0833C45.4723 49.0277 43.1112 49.9999 40.3334 49.9999C37.5556 49.9999 35.1945 49.0277 33.2501 47.0833C31.3056 45.1388 30.3334 42.7777 30.3334 39.9999C30.3334 37.4444 31.1529 35.2337 32.7917 33.3678C34.4306 31.5023 36.4816 30.4028 38.9447 30.0695V26.1666C35.4169 26.5091 32.4516 27.9952 30.0488 30.6249C27.6461 33.2546 26.4447 36.3796 26.4447 39.9999C26.4447 43.8702 27.7919 47.1526 30.4863 49.847C33.1808 52.5415 36.4631 53.8887 40.3334 53.8887C44.2037 53.8887 47.4861 52.5415 50.1805 49.847C52.8749 47.1526 54.2222 43.8702 54.2222 39.9999C54.2222 37.9908 53.8333 36.1251 53.0555 34.4028C52.2777 32.6806 51.2083 31.1806 49.8472 29.9028L51.8334 27.9166C53.4168 29.4444 54.6737 31.243 55.6043 33.3124C56.5348 35.3819 57.0001 37.611 57.0001 39.9999C57.0001 42.3055 56.5626 44.4721 55.6876 46.4999C54.8126 48.5277 53.6251 50.2916 52.1251 51.7916C50.6251 53.2916 48.8612 54.4791 46.8334 55.3541C44.8056 56.2291 42.639 56.6666 40.3334 56.6666Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio3);
export default __webpack_public_path__ + "static/media/portfolio3.ce1a5449fa0230296888dacb805c08e3.svg";
export { ForwardRef as ReactComponent };